// Copyright 2025, University of Maryland, All Rights Reserved
import { Button } from '@/components/ui'

export default function AccessDenied() {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="flex flex-col items-center justify-center min-h-[60vh]">
        <div className="bg-card p-8 rounded-lg shadow-md max-w-md w-full border">
          <h1 className="text-2xl font-bold mb-4 text-destructive">Access Denied</h1>
          <p className="text-muted-foreground mb-6">
            You do not have permission to access this application.
            Please contact your administrator if you believe this is an error.
          </p>
          <Button variant="destructive" onClick={() => window.location.reload()}>
            Refresh Page
          </Button>
        </div>
      </div>
    </div>
  )
}